import { useCallback, useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Input from "@mui/material/Input";
import Delete from "@mui/icons-material/Delete";

interface propsType {
  question: string;
  answers: any;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "700px",
  bgcolor: "background.paper",
  border: "0px solid #000",
  borderRadius: "4px",
  boxShadow: 24,
  pl: 2,
  pr: 2,
  pb: 3,
  pt: 1,
};

const PopAnswers = (props: propsType, ref: any) => {
  const indexNameRef: any = useRef();

  const [openModal, setOpenModal] = useState(false);

  function DocsRow(props: { docInfo: ReturnType<any> }) {
    const { docInfo } = props;
    const [open, setOpen] = useState(false);

    return (
      <>
        <TableRow key={docInfo.id} sx={open ? {} : { "& > *": { borderBottom: "unset" } }}>
          <TableCell width={20}>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {docInfo.id} [{docInfo.score}]
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ p: 2, whiteSpace: "pre-line" }}>{docInfo.text}</Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  useEffect(() => {
    return () => {
      setOpenModal(false);
    };
  }, []);

  const open = useCallback((open: boolean) => {
    setOpenModal(open);
  }, []);

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack direction="column" spacing={0}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <IconButton
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                <CloseIcon className="color-red" />
              </IconButton>
            </Box>
            <Stack direction="column" spacing={2}>
              <TextField id="txtQuestion" value={props.question} variant="outlined" fullWidth />
              <TableContainer component={Paper} sx={{ height: "598px", overflowY: "auto" }}>
                <Table className="data-table">
                  <TableBody>
                    {props.answers.map((docInfo: any, index: number) => (
                      <DocsRow key={docInfo.id + "" + index} docInfo={docInfo} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default forwardRef(PopAnswers);
